'use strict';

exports.__esModule = true;
exports['default'] = deepEquals;
var hasOwn = Object.prototype.hasOwnProperty;

function deepEquals(equals, deepObjects) {
  function deep(valueA, valueB) {
    if (equals(valueA, valueB)) {
      return true;
    }

    if (Array.isArray(valueA)) {
      if (!Array.isArray(valueB) || valueA.length !== valueB.length) {
        return false;
      }
      for (var index = 0; index < valueA.length; index++) {
        if (!deep(valueA[index], valueB[index])) {
          return false;
        }
      }
      // could not find unequal items
      return true;
    }

    if (Array.isArray(valueB)) {
      return false;
    }

    if (typeof valueA === 'object') {
      if (typeof valueB !== 'object') {
        return false;
      }

      var isANull = valueA === null;
      var isBNull = valueB === null;
      if (isANull || isBNull) {
        return isANull === isBNull;
      }

      var aKeys = Object.keys(valueA);
      var bKeys = Object.keys(valueB);

      if (aKeys.length !== bKeys.length) {
        return false;
      }

      for (var index = 0; index < aKeys.length; index++) {
        var key = aKeys[index];
        if (hasOwn.call(valueA, key) && (!hasOwn.call(valueB, key) || !(deepObjects ? deep : equals)(valueA[key], valueB[key]))) {
          return false;
        }
      }
      // could not find unequal keys or values
      return true;
    }
    return false;
  }

  return deep;
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/lru-memoize/lib/deepEquals.js
 ** module id = 967
 ** module chunks = 0
 **/